import Layout from '../../internal/Layout.vue'
import CostCenterPage from './CostCenter/CostCenter.vue'

const CostCenterRoutes = {
  component: Layout,
  children: [
    {
      name: 'costCenter',
      path: '/',
      component: CostCenterPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default CostCenterRoutes
